import { TableWithStoredSettingsAndLayoutSettings } from '@Components/Tables';
import { initialInvoiceSnapshotSorting, openInvoiceSnapshotColumns } from '@Constants/TableColumns';
import { useLoadUnpaidInvoiceSnapshots } from '@Hooks/Billing';
import { useRemoteCacheInvalidation } from '@Hooks/useRemoteCacheInvalidation';
import { ApiInvoiceSnapshot, EnumFrontendLayoutSetting } from '@Model';
import { useTableRefetch } from '@synqo/frontend-component-library';
import { useMemo } from 'react';
import type { IInvoiceSnapshotViewProps } from './invoiceSnapshotListProps';

interface IFrameListOpenInvoiceSnapshotsProps extends IInvoiceSnapshotViewProps {}

const emptyItems: ApiInvoiceSnapshot[] = [];

export function FrameListOpenInvoiceSnapshots({
    objectSelector,
    onLoaderDone,
    toolbarElements,
    rowActionsColumn,
}: IFrameListOpenInvoiceSnapshotsProps) {
    const { refetchRef, refetchTable } = useTableRefetch();
    useRemoteCacheInvalidation('invoice_snapshots', refetchTable);

    const listApi = useLoadUnpaidInvoiceSnapshots();

    const columns = useMemo(
        () =>
            rowActionsColumn === undefined
                ? openInvoiceSnapshotColumns
                : [...openInvoiceSnapshotColumns, rowActionsColumn],
        [rowActionsColumn],
    );

    return (
        <TableWithStoredSettingsAndLayoutSettings<ApiInvoiceSnapshot>
            layoutSettingsContext={EnumFrontendLayoutSetting.InvoiceSnapshotsTableLayout}
            items={emptyItems}
            name="OposInvoiceSnapshotList"
            columns={columns}
            loader={listApi.loadPage}
            onLoaderDone={onLoaderDone}
            refetchRef={refetchRef}
            initialSorting={initialInvoiceSnapshotSorting}
            canCreate={false}
            objectSelector={objectSelector}
            toolbarElements={toolbarElements}
            useOnClickNavigation
            fullSize
        />
    );
}
